/*
 * Copyright 2024 Larder Software Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export const LAUNCHDARKLY_PROJECT_KEY_ANNOTATION =
  'launchdarkly.com/project-key';
export const LAUNCHDARKLY_ENVIRONMENT_KEY_ANNOTATION =
  'launchdarkly.com/environment-key';
export const LAUNCHDARKLY_CONTEXT_PROPERTIES_ANNOTATION =
  'launchdarkly.com/context';
